import React, { Component } from 'react';
import { toast } from 'react-toastify';
import {
  ProgressIndicator,
  ProgressIndicatorSkeleton,
  ProgressStep,
  Modal,
  Loading,
} from 'carbon-components-react';
import { Breadcrumb } from '../../../../../components';
import { getByDmService, pathDmService } from '../../../../../services/Api';
import { getStatusCampaignPromotersIndex } from '../../../../../utils/modifiers';
import Detail from './Detail';
import {
  PENDENTE,
  APROVADO,
  CRIACAO,
  PRODUCAO,
  CONCLUIDO,
  CANCELADO,
  TRANSPORTE
} from '../../../../../config/StatusRequest';

class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      isLoading: true,
      isUpdating: false,
      openMdStatus: false,
      cancelModal: false,
    };
  }

  componentDidMount() {
    this.loadCampaignPromoters();
  }

  loadCampaignPromoters = async () => {
    const { match } = this.props;
    try {
      const data = await getByDmService('/Pedido/GetCampanhaPromocional', match.params.id);
      this.setState({ data, isLoading: false });
    } catch (e) {
      toast.error('Ocorreu um erro ao carregar a campanha');
      this.setState({ data: null, /* error: e, */ isLoading: false });
    }
  };

  toggleUpdateModal = () => {
    this.setState(prevState => ({ openMdStatus: !prevState.openMdStatus }));
  };

  toogleCancelModal = () => {
    this.setState(prevState => ({
      cancelModal: !prevState.cancelModal
    }));
  };

  updateOrderStatus = async () => {
    const { data } = this.state;
    const { match } = this.props;
    const { id } = match.params;
    const arrStatus = [
      PENDENTE.id,
      APROVADO.id,
      CRIACAO.id,
      PRODUCAO.id,
      TRANSPORTE.id,
      CONCLUIDO.id,
      CANCELADO.id
      
    ];

    const index = arrStatus.indexOf(data.status.id) + 1;
    const serviceUrl = `/Pedido/AtualizaStatus/${id}?status=${arrStatus[index]}&retirouUniforme=&dataRetiradaUniforme=`;

    this.updateStatus(serviceUrl, index);
  };

  cancelRequest = () => {
    const { match } = this.props;
    const { id } = match.params;
    const serviceUrl = `/Pedido/AtualizaStatus/${id}?status=${CANCELADO.id}&retirouUniforme=&dataRetiradaUniforme=`;

    this.updateStatus(serviceUrl, 6);
  };

  updateStatus = async (serviceUrl, indexMsg) => {
    const { history } = this.props;
    const messages = [
      'Status alterado para preparação',
      'Status alterado para Aprovado',
      'Status alterado para Criação',
      'Status alterado para Produção',
      'Status alterado para Transporte',
      'Status alterado para Concluído',
      'Status alterado para Cancelado'
    ];

    try {    
      await toast.success(messages[indexMsg]);
      if (indexMsg <= 6) {        
        if(indexMsg === 6){
          await pathDmService(serviceUrl, {});      
          this.toogleCancelModal();   
        }else{    
          await this.toggleUpdateModal();
        }
        await pathDmService(serviceUrl, {});
        await this.loadCampaignPromoters();

      } else {
        
        await history.push('/trade/admin/campanhas-promocionais');
      }
    } catch (error) {
      toast.warn('Um erro inesperado ocorreu ao tentar modificar o status');     
    }
  };

  changeTab = ({ index }) => {
    const { match, history } = this.props;
    const route = index === 0 ? 'detalhe' : 'informacoes';
    history.push(`${match.url}/${route}`);
  };

  nameButtonStatus = status => {
    if (status === PENDENTE.id) {
      return APROVADO.value;
    }
    if (status === APROVADO.id) {
      return CRIACAO.value;
    }
    if (status === CRIACAO.id) {
      return PRODUCAO.value;
    }
    if (status === PRODUCAO.id) {
      return TRANSPORTE.value;
    }
    if (status === TRANSPORTE.id) {
      return CONCLUIDO.value;
    }    
    if (status === CONCLUIDO.id) {
      return CANCELADO.value;
    }
    return false;
  };

  titlesModalConfirmStatus = status => {
    if (status === PENDENTE.id) {
      return PENDENTE.value;
    }
    if (status === APROVADO.id) {
      return APROVADO.value;
    }
    if (status === CRIACAO.id) {
      return CRIACAO.value;
    }
    if (status === PRODUCAO.id) {
      return PRODUCAO.value;
    }
    if (status === TRANSPORTE.id) {
      return TRANSPORTE.value;
    }    
    if (status === CONCLUIDO.id) {
      return CONCLUIDO.value;
    }
    return false;
  };

  buttonRenderRight(statusIndex) {
    const { data } = this.state;

    return (
      <div>
        {statusIndex <= 1 &&
          data.status.id !== 5 && (
            <button
              className="bx--btn btn-primary-outlined h-sm-margin"
              onClick={() => {this.toogleCancelModal()}}
              type="submit"
            >
              Cancelar Pedido
            </button>
          )}
        {statusIndex  < 6 && (
          <button
            className="bx--btn btn-secondary-color h-sm-margin"
            onClick={this.toggleUpdateModal}
            type="submit"
          >
            {this.nameButtonStatus(data.status.id)}
          </button>
        )}
        {data.status.id === 5 && <h3 className="text-warning">Pedido Cancelado</h3>}
      </div>
    );
  }

  render() {
    const { data, isLoading, isUpdating, openMdStatus, cancelModal } = this.state;
    const { history, match } = this.props;
    const { path } = match;
    const isStore = path === "/trade/campanhas-promocionais/visualizar/:id";

    const orderStatus = data && data.status;

    if (isLoading) {
      return (
        <div>
          <Breadcrumb title="---- - ----" description="----" />

          <section className="content-wrapper content-wrapper--large">
            <ProgressIndicatorSkeleton />
          </section>
        </div>
      );
    }

    const statusIndex = getStatusCampaignPromotersIndex(orderStatus ? orderStatus.id : {});
    return (
      <div>
        {data && (
          <div>
            {!isStore ? (
              <Breadcrumb
                title={`${data.numero} - ${data.dataSolicitacaoFormata} - ${data.descricao}`}
                description={`Criada por ${data.solicitante.nome}`}
                renderRight={this.buttonRenderRight(statusIndex)}
                renderLeft={(() => (
                  <div className="breadcrumb-left-actions pointer" onClick={() => history.goBack()}>
                    <svg width="16" height="14" viewBox="0 0 16 14">
                      <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                    </svg>
                  </div>
                ))()}
              />
            ) :
              (
                <Breadcrumb
                  title={`${data.numero} - ${data.dataSolicitacaoFormata} - ${data.descricao}`}
                  description={`Criada por ${data.solicitante.nome}`}
                />
              )
            }

            <section className="content-wrapper content-wrapper--large">
              {!isStore && (
                <ProgressIndicator className="v-xl-margin" currentIndex={statusIndex}>
                  <ProgressStep label="Pendente" />
                  <ProgressStep label="Aprovado" />
                  <ProgressStep label="Criação" />
                  <ProgressStep label="Produção" />
                  <ProgressStep label="Transporte" />
                  <ProgressStep label="Concluído" />
                  <ProgressStep label="Cancelado" />
                </ProgressIndicator>
              )}


              <Detail
                reloadCampaign={() => this.loadCampaignPromoters()}
                data={data}
                {...this.props}
              />

              <Modal
                open={openMdStatus}
                onRequestSubmit={this.updateOrderStatus}
                onRequestClose={this.toggleUpdateModal}
                modalHeading="Modificar Status"
                primaryButtonText="Tenho certeza"
                secondaryButtonText="Cancelar"
              >
                <div>
                  <p>
                    Você tem certeza que deseja alterar o status do pedido
                    <strong>
                      {` ${data.numero} `}
                    </strong>
                    de
                    {' '}
                    <strong>
                      {' '}
                      {this.titlesModalConfirmStatus(data.status.id)}
                      {' '}
                    </strong>
                    {' '}
                    para
                    {' '}
                    <strong>
                      {' '}
                      {this.nameButtonStatus(data.status.id)}
                      {' '}
                    </strong>
                    ?
                  </p>
                </div>
              </Modal>

              <Modal
                open={cancelModal}
                onRequestSubmit={() => this.cancelRequest()}
                onRequestClose={() => this.toogleCancelModal()}
                modalHeading="Cancelar Pedido"
                primaryButtonText="Tenho certeza"
                secondaryButtonText="Cancelar"
              >
                <div className="warning-modal-txt">
                  <p>Você tem certeza que deseja cancelar este pedido?</p>
                </div>
              </Modal>
              {isUpdating && <Loading small />}

            </section>

          </div>
        )}
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/screens/admin/Trades/Campaign/Detail/Main.js